<template>
  <vs-popup
    class="view-schedule-event"
    id="popup"
    :title="''"
    @close="open = false"
    :active.sync="open"
    :buttons-hidden="true"
  >
    <div no-shadow>
      <h5 class="mb-8">{{ event.title || 'Event Information' }}</h5>

      <div v-if="event.data && Object.keys(event.data).length" class="event-details">
        <div
          v-for="(value, key) in event.data"
          :key="key"
          class="detail-row"
        >
          <span class="detail-key">{{ formatKey(key) }}</span>
          <span class="detail-value">{{ value }}</span>
        </div>
      </div>

      <div v-else class="text-center text-gray-500">
        No event data available.
      </div>

      <div class="flex flex-wrap items-center justify-center mt-8">
        <vs-button
          :color="event.backgroundColor"
          @click.stop="onClickEvent()"
          icon-pack="feather"
          icon="icon-external-link"
          type="filled"
          class="mt-2"
        >
          Open
        </vs-button>
      </div>
    </div>
  </vs-popup>
</template>


<script>
function initialState() {
  return {
    open: false,
    event: {},
    eventHyperlinks: {
      'Raw Material Order': '/pages/raw-materials/orders/<id>',
      'Scheduled Task': '/pages/task-instance/<id>',
      'Other Order': '/pages/other-supplier-service/orders/<id>',
      'Sales Order': '/pages/product-orders/<id>',
      'Work Order': '/pages/manufacturing/work-orders/<id>/details',
      'Staff Task': '/pages/tasks/<id>',
      'Staff Leave': '/pages/manage-nimble/users?step=3'
    },
  }
}

export default {
  name: 'ViewCompanyScheduleEventPopUp',
  data() {
    return initialState()
  },
  methods: {
    async openPopup(event) {
      try {
        await Object.assign(this.$data, initialState());
        // this.open = true;
        Object.assign(this.event, event)
        this.onClickEvent()
      } catch (error) {
        console.error(error);
      }
    },
    onClickEvent() {
      try {
        const eventType = this.event.type
        const id = this.event.id

        if (!eventType || !id) {
          this.$vs.notify({
            color: 'warning',
            title: 'Missing Data',
            text: 'Event type or ID not found.',
          })
          return
        }

        const baseUrl = this.eventHyperlinks[eventType]
        if (!baseUrl) {
          // this.$vs.notify({
          //   color: 'danger',
          //   title: 'Unknown Event Type',
          //   text: `No hyperlink defined for type "${eventType}"`,
          // })
          return
        }

        const finalUrl = baseUrl.replace('<id>', id)
        switch(eventType) {
          case 'Staff Task':
            this.$store.commit('TOGGLE_SIDE_TASK_BAR', { active: true, id: id });
            return
          default:
            window.open(finalUrl, '_blank')
        }
      } catch (err) {
        console.error('Error opening event:', err)
      }
    },
    formatKey(key) {
      return key
        .replace(/_/g, ' ')
        .replace(/\b\w/g, (char) => char.toUpperCase())
    },
  },
}
</script>

<style scoped>
.event-details {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.detail-row {
  display: flex;
  justify-content: space-between;
  padding: 6px 0;
  border-bottom: 1px solid #f1f1f1;
}

.detail-key {
  font-weight: 600;
  text-transform: capitalize;
}

.detail-value {
  word-break: break-all;
}

.view-schedule-event>>>.vs-popup {
  min-width: 25% !important;
}
</style>

